import { useTranslation } from 'react-i18next'

const input = 'h-9 w-full rounded-lg border border-slate-200 px-3 text-sm text-slate-900 disabled:bg-slate-50'

// Link attachments of an entry: `[{ url, label }]`. Links only: product
// pictures come from the catalog, so there is no image control.
export default function FaqAttachments({ links, onChange, max, labelMax, readOnly = false }) {
  const { t } = useTranslation()
  const change = (index, field, value) => {
    onChange(links.map((link, position) => (position === index ? { ...link, [field]: value } : link)))
  }

  return (
    <div className="flex flex-col gap-2">
      {links.map((link, index) => (
        // The row's position is its identity: rows have no id and may hold equal text.
        <div key={index} className="flex flex-col gap-1 rounded-lg border border-slate-100 p-2">
          <input
            type="url"
            value={link.url}
            onChange={(event) => change(index, 'url', event.target.value)}
            placeholder="https://"
            aria-label={t('faq.panel.linkUrl', { number: index + 1 })}
            disabled={readOnly}
            className={input}
          />
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={link.label}
              maxLength={labelMax}
              onChange={(event) => change(index, 'label', event.target.value)}
              placeholder={t('faq.panel.linkLabelPlaceholder')}
              aria-label={t('faq.panel.linkLabel', { number: index + 1 })}
              disabled={readOnly}
              className={input}
            />
            {!readOnly && (
              <button
                type="button"
                onClick={() => onChange(links.filter((_link, position) => position !== index))}
                aria-label={t('faq.panel.removeLink', { number: index + 1 })}
                className="shrink-0 text-sm font-medium text-red-600"
              >
                {t('faq.panel.delete')}
              </button>
            )}
          </div>
        </div>
      ))}
      {!readOnly && links.length < max && (
        <button
          type="button"
          onClick={() => onChange([...links, { url: '', label: '' }])}
          className="self-start text-sm font-semibold text-[#1535c8]"
        >
          {t('faq.panel.addLink')}
        </button>
      )}
    </div>
  )
}
